export default __webpack_public_path__ + "static/media/Gyre of the Cloudcleaver.25dc2555.jpg";